/**
 * Format price as Indonesian Rupiah without decimal places
 * @param price - The price to format
 * @returns Formatted price string (e.g., "Rp 10,000")
 */
export const formatCurrency = (price: number): string => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .format(price)
    .replace("IDR", "Rp");
};

/**
 * Format price as Indonesian Rupiah with decimal places (for cases where decimals are needed)
 * @param price - The price to format
 * @returns Formatted price string with decimals (e.g., "Rp 10,000.50")
 */
export const formatCurrencyWithDecimals = (price: number): string => {
  return `Rp ${price.toLocaleString("id-ID")}`;
};

/**
 * Format price as Indonesian Rupiah with compact "K" notation.
 * Always shows value in thousands without decimal place
 * if the price is ≥ 1.000 or ≤ -1.000. Otherwise shows full number.
 *
 * Examples:
 *   500      -> "Rp 500"
 *   1250     -> "Rp 1K"
 *   1234567  -> "Rp 1.235K"
 */
export const formatCurrencyWithNotation = (price: number): string => {
  const formatter = Intl.NumberFormat("id-ID", {
    maximumFractionDigits: 0,
  });

  if (price >= 1000 || price <= -1000) {
    const thousands = price / 1000;
    return `Rp ${formatter.format(thousands)}K`;
  }

  return `Rp ${formatter.format(price)}`;
};
